import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/toTop.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d2098e6e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "box"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "mt-5"
  }, null, -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "库存排行榜", -1);
});
var _hoisted_7 = {
  class: "rankList"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});
var _hoisted_9 = [_hoisted_8];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_line_echart = _resolveComponent("line-echart");
  var _component_rank_list_item = _resolveComponent("rank-list-item");
  var _component_van_collapse = _resolveComponent("van-collapse");
  var _component_van_list = _resolveComponent("van-list");
  var _component_c_nothing = _resolveComponent("c-nothing");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _hoisted_5, _createVNode(_component_line_echart, _normalizeProps(_guardReactiveProps(_ctx.saleTrend)), null, 16), _hoisted_6, _createElementVNode("div", _hoisted_7, [_ctx.rankData.length ? (_openBlock(), _createBlock(_component_van_list, {
    key: 0,
    loading: _ctx.loading,
    "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.loading = $event;
    }),
    finished: _ctx.finished,
    "finished-text": "没有更多了",
    onLoad: _ctx.onLoad
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_collapse, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.activeName = $event;
        }),
        accordion: ""
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankData, function (item, index) {
            return _openBlock(), _createBlock(_component_rank_list_item, {
              key: index,
              index: index,
              item: item
            }, null, 8, ["index", "item"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])];
    }),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])) : _createCommentVNode("", true), !_ctx.rankData.length ? (_openBlock(), _createBlock(_component_c_nothing, {
    key: 1
  })) : _createCommentVNode("", true)])]), _createElementVNode("div", {
    class: "goTop",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    function () {
      return _ctx.goTop && _ctx.goTop.apply(_ctx, arguments);
    })
  }, _hoisted_9)]);
}